import hljs from 'highlight.js/lib/core';
import jsPlugin from 'highlight.js/lib/languages/javascript';
import tsPlugin from 'highlight.js/lib/languages/typescript';

hljs.registerLanguage('js', jsPlugin);
hljs.registerLanguage('ts', tsPlugin);

export default function useHighlight(){
    document.querySelectorAll('pre code').forEach(x => {
        x.innerHTML = hljs.highlight(x.classList.contains('ts') ? 'ts' : 'js', x.innerHTML.trim()).value;
    })
}